module.exports = __webpack_public_path__ + "img/22.9e9d7bd5.png";